import { isDefined } from '@sgme/fp';
import type { HelpCenterContext } from 'state/helpRequest/state';
import type { AppState } from 'state/state.model';

export function getCurrentContext({ helpCenter }: AppState): HelpCenterContext | undefined {
  if (!isDefined(helpCenter.currentContext)) {
    return undefined;
  }
  return helpCenter.contexts[helpCenter.currentContext];
}

export function isOpen({ helpCenter }: AppState) {
  return isDefined(helpCenter.currentContext);
}

export function getTopicToOpen({ helpCenter }: AppState) {
  return helpCenter.topicToBeOpened;
}
